module.exports = __webpack_public_path__ + "img/message-ot.9a8f4962.png";